module.exports = __webpack_public_path__ + "static/assets/8f0077054b8958b18b383ff2103ac947.png";